




import Vue from "vue";

import moment from "moment-timezone";

import {
  Dame,
  Termin,
  PopoverMode,
  ContextMenuItem,
  ContextMenuItems,
  MassageArt,
  massagearten,
  currentTimestamp,
} from "@/api/Termine";

export interface MenuItemSelected {
  popoverMode: PopoverMode;
  dame: Dame;
  dame2: Dame;
  zeitslot: number;
  termin?: Termin;
}

export default Vue.extend({
  name: "BelegungsplanContextMenu",
  data() {
    return {
      contextMenuEntries: [] as ContextMenuItems,
    };
  },
  methods: {
    open(dame: Dame, zeitslot: number, termin?: Termin) {
      const fn = (action: PopoverMode) => {
        return ((originalEvent: Event, item: ContextMenuItem) =>
          this.onSelectContextmenu(
            originalEvent,
            action,
            dame,
            zeitslot,
            termin
          )).bind(this);
      };

      if (termin) {
        // Kontextmenü eines Termines
        // TODO: Berechtigungen prüfen
        this.contextMenuEntries = [
          {
            label: "Termindetails",
            icon: "pi pi-fw pi-info", // pi-info-circle
            command: fn("info"),
            visible: true,
          },
          {
            label: "Termin beginnt",
            icon: "pi pi-fw pi-clock",
            command: fn("beginnt"),
            visible: true,
          },
          {
            label: "Bearbeiten",
            icon: "pi pi-fw pi-pencil",
            command: fn("edit"),
            visible: true,
          },
          {
            label: "Duplizieren",
            icon: "pi pi-fw pi-copy",
            command: fn("duplicate"),
            visible: true,
          },
          {
            label: termin.geblockt ? "Stornieren" : "Löschen",
            icon: "pi pi-fw pi-trash",
            command: fn("delete"),
            visible: true,
          },
        ];
        if (termin.abgesagt) {
          this.contextMenuEntries.splice(1, this.contextMenuEntries.length - 1);
        } else if (termin.geblockt) {
          this.contextMenuEntries.splice(3, 1);
          this.contextMenuEntries.splice(1, 1);
        } else if (
          moment(termin.zeit)
            .format()
            .substring(0, 10) !=
          currentTimestamp()
            .format()
            .substring(0, 10)
        ) {
          this.contextMenuEntries.splice(1, 1);
        }
      } else {
        this.contextMenuEntries = [
          {
            label: `Termin für ${dame.kuenstlername} anlegen`,
            icon: "pi pi-fw pi-calendar-plus",
            command: fn("create"),
            visible: true,
          },
          {
            label: `${dame.kuenstlername} blocken`,
            icon: "pi pi-fw pi-lock",
            command: fn("block"),
            visible: true,
          },
        ];
      }

      const contextMenu: any = this.$refs.contextMenu;
      contextMenu.show(event);
    },

    // Auswahl eines Kontextmenü-Eintrags
    onSelectContextmenu(
      event: any,
      action: string,
      dame: Dame,
      zeitslot: number,
      termin?: Termin
    ) {
      console.log(event);
      console.log(action);
      console.log(dame);
      console.log(termin);
      console.log(zeitslot);
      this.$emit("select", {
        popoverMode: action,
        dame,
        zeitslot,
        termin,
      } as MenuItemSelected);
    },
  },
});
